import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FaqAnswer } from '../../_models/faq/faq.model';

@Component({
    selector: 'faq-answers',
    templateUrl: './faq-answers.component.html',
    styleUrls: ['./faq-answers.component.css'],
    standalone: false
})
export class FaqAnswersComponent implements OnInit {
  @Input() faqAnswers: FaqAnswer[];
  @Input() area: string;
  @Input() issue: string;


  public answers = new Array<FaqAnswer>();

  constructor() { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.faqAnswers) {
      this.answers = this.faqAnswers;
    } else if (changes.area && changes.issue) {
      this.getAreaIssueSpecificAnswer();
    }
    
  }

  private getAreaIssueSpecificAnswer(): void {

    setTimeout(() => {
      let answer1 = new FaqAnswer();
      answer1.type = "Text";
      answer1.order = 1;
      answer1.body = "Answer 1";

      let answer2 = new FaqAnswer();
      answer2.type = "Text";
      answer2.order = 2;
      answer2.body = "Answer 2";

      let answer3 = new FaqAnswer();
      answer3.type = "Text";
      answer3.order = 3;
      answer3.body = "Answer 3";

      let answer4 = new FaqAnswer();
      answer4.type = "Text";
      answer4.order = 4;
      answer4.body = "Answer 4";

      this.answers.push(answer1, answer2, answer3, answer4);
    }, 2000);
  }

}
